export default __webpack_public_path__ + "static/media/top-banner.634bd3a3.jpg";